import { css } from '@emotion/css';

import {
  temporalToolbarButtonStyle,
  temporalToolbarGroupStyle,
  temporalToolbarIconButtonStyle,
  temporalToolbarRangeGroupStyle,
  temporalToolbarRangeTitleStyle,
  temporalToolbarStyle,
} from '../../../shared/toolbar/temporal-toolbar-css.js';

export const TIME_AXIS_HEADER_HEIGHT = 40;
export const ROW_HEIGHT = 40;

export const timeAxisHeaderStyle = css({
  position: 'relative',
  zIndex: 2,
  display: 'flex',
  height: `${TIME_AXIS_HEADER_HEIGHT}px`,
  borderBottom: '1px solid var(--streamlain-v2-layer-insideBorder-border)',
  background:
    'var(--streamlain-gantt-header-background, var(--streamlain-v2-layer-background-primary))',
  overflow: 'hidden',
});

export const tickLabelStyle = css({
  position: 'absolute',
  top: 0,
  height: `${TIME_AXIS_HEADER_HEIGHT}px`,
  display: 'flex',
  alignItems: 'center',
  paddingInline: '8px',
  fontSize: '11px',
  color: 'var(--streamlain-v2-text-secondary)',
  borderLeft: '1px solid var(--streamlain-v2-layer-insideBorder-border)',
  whiteSpace: 'nowrap',
  pointerEvents: 'none',
  userSelect: 'none',
  overflow: 'hidden',
  textOverflow: 'ellipsis',

  // Zoom-specific max-width so labels never bleed into the next cell.
  // Day columns are 60 px (PX_PER_DAY_BY_ZOOM.day), week 140, month 180,
  // quarter 180 — matching values minus a small gap keep ticks readable
  // without visual overlap. `&[data-zoom=...]` = (0,2,0) is enough here
  // (no viewport `*` override targets data attributes directly).
  '&[data-zoom=day]': { maxWidth: '58px' },
  '&[data-zoom=week]': { maxWidth: '138px' },
  '&[data-zoom=month]': { maxWidth: '178px' },
  '&[data-zoom=quarter]': { maxWidth: '178px' },
});

export const todayIndicatorStyle = css({
  position: 'absolute',
  top: 0,
  bottom: 0,
  width: '2px',
  background: 'var(--streamlain-v2-status-error)',
  zIndex: 10,
  pointerEvents: 'none',
});

export const zoomToolbarStyle = temporalToolbarStyle;

export const zoomGroupStyle = temporalToolbarGroupStyle;

export const zoomNavGroupStyle = temporalToolbarRangeGroupStyle;

export const zoomActionGroupStyle = temporalToolbarGroupStyle;

export const zoomButtonStyle = temporalToolbarButtonStyle;

export const zoomIconButtonStyle = temporalToolbarIconButtonStyle;

export const zoomRangeTitleStyle = temporalToolbarRangeTitleStyle;

export const todayButtonStyle = css({
  fontWeight: 500,
});
